import initialState from "./initialState";
import types from "../actions/actionTypes";
import _ from "lodash";

import Tools from "../../helpers/tools";
import ConnectedServices from "../../helpers/vehicle/connectedServices";

export default function customerReducer(state, action) {
	switch (action.type) {
		case types.VEHICLE.SET:
			return setVehicleData(action.vehicle);
		case types.VEHICLE.DELETE_DEVICE:
			return deleteDevice(state);
		default:
			return state || initialState.loadInitials().vehicle;
	}
}

function deleteDevice(state) {
	const newState = _.cloneDeep(state);
	newState.cp.device = {};
	return {
		...newState
	};
}

export function formatVehicleUioData(vehicleUio) {
	const registrations = _.get(vehicleUio, `_embedded.registrations`);
	const licencePlate = _.get(_.first(registrations), `registrationNumber`);
	const model = _.get(vehicleUio, `production.project.modelName`);
	const engineDescription = _.get(vehicleUio, `production.lineupElements.engine.description`),
		engineFuelType = _.get(vehicleUio, `production.lineupElements.engine.fuelTypeDescription`);
	const engine = `${engineDescription} ${engineFuelType}`;
	const transmission = _.get(vehicleUio, `production.lineupElements.transmission.transmissionTypeDescription`);
	const productionDate = _.get(vehicleUio, `production.productionDate`);
	const year = productionDate && parseInt(productionDate);
	return { licencePlate, model, engine, transmission, year };
}

function formatCPData(vehicle) {
	const users = _.get(vehicle, `cp.users`, _.get(vehicle, `users`));
	return _.isArray(users) && users.map(user => {
		const result = _.pick(user, [ `createdBy`, `claimedBy`, `isOwner`,
			`entitledBy`, `isEntitled`, `alias`, `uuid`, `details` ]);

		result.createdOn = Tools.formatDate(user.createdOn);
		result.modifiedOn = Tools.formatDate(user.modifiedOn);
		result.claimedOn = Tools.formatDate(user.claimedOn);
		result.entitledOn = Tools.formatDate(user.entitledOn);

		const devicesWithoutRepairStateAndConnectedEligible = vehicle.connected.filter(device =>
			_.get(device, `state`) !== `REPAIR`
			&& _.includes(window.cpAdmin.connectedSupportedDevices, _.get(device, `provider`)));
		const device = _.some(devicesWithoutRepairStateAndConnectedEligible)
			&& devicesWithoutRepairStateAndConnectedEligible[0];
		result.connectedServiceStatus = ConnectedServices.getStatus(device, result.uuid);

		return result;
	});
}

export function formatPrivacyData(vehicleCms) {
	return _.get(vehicleCms, `privacy`);
}

export function formatConnectedData(devices) {
	const deviceConnected = {};
	const deviceWithAutomaticMMRegistration = devices.find(device => _.get(device, `hasAutomaticMMRegistration`));
	const dcmDevice = ConnectedServices.getDCMDeviceType(devices);

	if (deviceWithAutomaticMMRegistration) {
		deviceConnected.device = { id: deviceWithAutomaticMMRegistration.deviceId };
		deviceConnected.hasAutomaticMMRegistration = true;
	}
	if (dcmDevice) {
		deviceConnected.dcmType = dcmDevice;
	}
	return deviceConnected;
}

function setVehicleData(vehicle) {
	if (_.isEmpty(vehicle)) {
		vehicle = {};
	} else {
		vehicle.cp.users = formatCPData(vehicle);
		vehicle.uio = formatVehicleUioData(vehicle.uio);
		vehicle.privacy = formatPrivacyData(vehicle.cms);
		vehicle.connected = formatConnectedData(vehicle.connected);

		delete vehicle.cms;
	}
	return vehicle;
}